import { Session } from 'app/services/session/types';
import { Global } from 'constants/index';

const getSession = () => {
  const data = localStorage.getItem(Global.AUTH_KEY);
  if (data) return JSON.parse(data) as Session || null;
  return null;
};

export { getSession };